<template>
  <div>
    <div
      id="alert"
      class="alert alert-dismissible fade show m-alert m-alert--outline mb-4 mt-4"
      :class="alert.color"
      role="alert"
      v-if="alert.message"
      ref="alert"
    >
      <button
        type="button"
        class="close"
        aria-label="Close"
        @click="alert.message = ''"
      ></button>
      <i :class="alert.icon"></i> &nbsp;
      <strong>{{ alert.message }}</strong>
      <br />
      {{ alert.reason }}
    </div>
    <div class="col-md-6" style="padding-left: 0">
      <div
        class="form-group"
        :class="{ 'has-danger': !this.proposal.product_id }"
      >
        <label for="product">Produto</label>
        <div class="input-group">
          <SelectProducts
            id="product"
            ref="product_id"
            :selected="this.proposal.product_id ? this.proposal.product_id : 0"
            :first="'Selecione um produto'"
            :productsNotAppear="[2, 3, 4, 5, 6]"
            @change="changeProduct($event)"
          />
        </div>
      </div>
    </div>

    <hr />
    <div
      class="m-accordion m-accordion--default"
      id="m_accordion"
      role="tablist"
    >
      <div
        class="m-accordion__item"
        v-for="detail in data"
        :key="detail.type_id"
      >
        <div
          class="m-accordion__item-head collapsed"
          role="tab"
          :id="`m_accordion_${detail.key}_head`"
          data-toggle="collapse"
          :href="`#m_accordion_${detail.key}_body`"
          aria-expanded="false"
        >
          <span class="m-accordion__item-icon">
            <i :class="detail.icon"></i>
          </span>
          <span class="m-accordion__item-title">
            {{ detail.type }}
          </span>
          <span class="m-accordion__item-mode"></span>
        </div>
        <div
          class="m-accordion__item-body collapse"
          :id="`m_accordion_${detail.key}_body`"
          role="tabpanel"
          :aria-labelledby="`m_accordion_${detail.key}_head`"
          data-parent="#m_accordion"
          style
        >
          <div
            class="m-accordion__item-content"
            v-if="isFixedValue(detail.key)"
          >
            <div>
              <div class="row">
                <div class="col-md-6">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text">Valor Mensal</span>
                    </div>
                    <money
                      v-bind="money"
                      class="form-control m-input"
                      v-model="detail.package"
                    ></money>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="m-accordion__item-content" v-else>
            <div>
              <div class="row">
                <div class="col-md-6">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text">Quantidade</span>
                    </div>
                    <input
                      type="number"
                      class="form-control"
                      v-model="detail.amount"
                      placeholder="0"
                    />
                  </div>
                </div>
              </div>
              <br />
              <div class="row">
                <div class="col-md-6">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text">Valor extra</span>
                    </div>
                    <money
                      v-bind="money"
                      class="form-control m-input"
                      v-model="detail.extra"
                    ></money>
                  </div>
                </div>
              </div>
              <br />
              <div class="row">
                <div class="col-md-6">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text">Valor fixo</span>
                    </div>
                    <money
                      v-bind="money"
                      class="form-control m-input"
                      v-model="detail.fixed"
                    ></money>
                  </div>
                </div>
              </div>
              <br />
              <div class="row">
                <div class="col-md-6">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text">Valor minimo</span>
                    </div>
                    <money
                      v-bind="money"
                      class="form-control m-input"
                      v-model="detail.minimal"
                    ></money>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr class="row mt-5 mb-3" />
      <div class="row mb-5 mt-5">
        <div class="col-md-12" style="text-align: right">
          <button @click.prevent="saveForm()" class="btn btn-success">
            <i class="fas fa-exclamation-triangle"></i>
            Salvar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { returnMessageFormMixin } from '@/mixins/returnMessageFormMixin.js';
import { tooltipMixin } from '@/mixins/tooltipMixin.js';
import SelectProducts from '@/components/forms/SelectProducts';

import { Money } from 'v-money';
import { baseApiUrl } from '@/global';
import axios from 'axios';

export default {
  mixins: [returnMessageFormMixin, tooltipMixin],
  props: {
    proposal: {},
  },
  name: 'ProposalServices',
  components: { Money, SelectProducts },
  data() {
    return {
      data: {
        detail: [],
      },
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false,
      },
      alert: {
        color: 'alert-primary',
        icon: 'fas fa-spinner fa-spin fa-lg',
        message: '',
        reason: '',
      },
      change_reason: null,
    };
  },
  methods: {
    isFixedValue(key) {
      return (
        key == 'package' ||
        key == 'consulting' ||
        key == 'support24x7' ||
        key == 'automatic_distribution' ||
        key == 'report'
      );
    },
    async saveForm() {
      await this.messageWaitingSave();

      const alertEl = this.$refs.alert;

      if (alertEl) {
        alertEl.scrollIntoView();
      }
      let url = `${baseApiUrl}/v1/proposal/service/save`;
      axios
        .post(url, this.data)
        .then((res) => {
          this.logMessageForm(res);
          this.callData();
        })
        .catch((error) => this.logMessageFormFailed(error.response));

      url = `${baseApiUrl}/v1/proposal/save`;
      axios
        .post(url, this.proposal)
        .then((res) => {
          this.logMessageForm(res);
          this.callData();
        })
        .catch((error) => this.logMessageFormFailed(error.response));
    },
    changeProduct(event) {
      this.proposal.product_id = event;
      this.getDatas();
    },
    getDatas() {
      const url = `${baseApiUrl}/v1/proposal/service/data/${this.proposal.id}/product/${this.proposal.product_id}`;
      axios(url).then((res) => {
        this.data = res.data;
      });
    },
    callData() {
      this.getDatas();
    },
    validateInfos() {
      let count = 0;
      $.each(this.data, (index, detail) => {
        if (detail.datas) {
          if (detail.datas.surplus_price > 0 && detail.datas.amount < 1) {
            count++;
          }
        }
      });
      return count > 0 ? false : true;
    },
  },
  computed: {
    proposalId() {
      return this.$store.state.showProposalSave;
    },
  },
  watch: {
    proposal(newProposal) {
      this.data = newProposal;
      this.getDatas();
    },
  },
};
</script>
